import type { PlatformStaff } from '@/types/platformStaff'

/** Any password is accepted in mock mode, same as the tenant-side login. */
export const platformStaffFixture: PlatformStaff[] = [
  {
    id: 'staff_0001',
    firstName: 'Alex',
    lastName: 'Marinescu',
    email: 'alex@ereach.ro',
    role: 'platform_admin',
    avatarColor: '#2F4CDD',
  },
  {
    id: 'staff_0002',
    firstName: 'Diana',
    lastName: 'Ionescu',
    email: 'diana@ereach.ro',
    role: 'support',
    avatarColor: '#16A34A',
  },
]
